module.exports = __webpack_public_path__ + "img/return.344fa9a8.png";